export default "__VITE_ASSET__XT2XREJb__"